<template>
  <div class="special-main">

    <div class="pt-e-detail">

<!--            <div style="position: absolute;width: 100%;left: 0;top: 0;opacity: 0.7;z-index: 99999;">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260709/5f26c48ac8ad0ef71962557155ec2ece.jpg" alt="">-->
<!--            </div>-->

      <div class="pt-e-banner">
        <div class="pt-e-banner-txt">
          <div class="p-title">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260701/592045dcfd2efe89cff733a1cd95561e.png" alt="">
          </div>
          <p>齿间未来 触手可及</p>
        </div>
        <div class="pt-e-banner-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260716/0be80ad2d36bd47da61a4a127d977ac3.jpg" alt="">
        </div>
      </div>

      <div class="promotional-cover" v-observe-visibility="(isVisible) => handleVisibility(isVisible, 0)">
        <div class="progress">
          <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>
        </div>
        <div class="mask">
          <div class="content">
            <h3>舒适</h3>
            <h3>高效</h3>
            <h3>便捷</h3>
            <div class="button">
              <view-button @onclick="openVideoModal(videoList[0].previewVideo)"></view-button>
            </div>
          </div>
        </div>
        <video class="background-video"
               :ref="videoList[0].ref"
               :src="videoList[0].video"
               muted
               playsinline
               loop
        ></video>
      </div>

      <div class="power-container">
        <h3 class="tit">耳目一新<br/>舒适高效新体验</h3>
        <h4>喷头升级 聚雾更稳</h4>
        <p class="desc">全新花瓣形喷嘴，水雾更集中，兼顾效率与舒适度</p>
        <p class="desc">清洁效率提升</p>
        <p class="num">35%</p>

        <div class="model">
          <p class="model-tit previous">旧</p>
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260703/2f5b5807fd06a8bb66ede4c0c9db2e2f.png" alt="">
          <p class="model-tit new">新</p>
        </div>
      </div>

      <div class="feature-container">
        <div class="feature-bg">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260703/0c3c75dfb26c805924fe287f8d4c38b2.jpg" alt="" />
        </div>
        <div class="feature-content">
          <p>舒适与声俱来</p>
          <p>常用4档水3档功率情况下仅75.8dB低音</p>
          <p>出水冲击力降低</p>

          <p>28.7%</p>
          <p>显著提升患者舒适度</p>
          <div class="params pt-e-c">
            <div class="pt-e">
              <p>Power level 6</p>
              <p>6.68g</p>
            </div>
            <p class="tit">PT-E</p>
          </div>
          <div class="params Standard-c">
            <div class="Standard">
              <p>Power level 6</p>
              <p>9.37g</p>
            </div>
            <p class="tit">PT-B</p>
          </div>
        </div>
      </div>

      <div class="heating-system-container">
        <h4>双路加热 温暖无惧敏感</h4>
        <p class="desc">超声喷砂双路加热，支持4种温度调节，喷砂: 25℃，30℃，35℃，40℃<br/>超声: 24℃，28℃，32℃，36℃，满足不同临床操作需求</p>
        <p class="desc"></p>
        <div class="heating-system-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/069a071925b9352562355c1021e54b36.jpg" alt="">
        </div>
        <div class="upgraded">
          <div class="img">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/589b2e2122f7407ceecfde5336e898ab.jpg" alt="">
          </div>
          <div class="txt">
            <h4>LED 喷砂手柄</h4>
            <h4>视野更清晰</h4>
            <p class="desc">带灯喷砂手柄专利设计<br/>为操作区提供清晰视野辅助</p>
            <p class="patent-num">专利号：2023214468365 一种带光的牙科喷砂手柄</p>
          </div>
        </div>
        <div class="titanium-alloy">
          <div class="txt">
            <h4>匠心甄选 钛合金材质手柄</h4>
            <p class="desc">手柄升级为高强度钛合金材质，具有更好的生物相容性<br/>
              更强的耐腐蚀性和耐磨性，提升医生使用过程稳定性与患者舒适度</p>
          </div>
          <div class="img">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/12c169213d07fc654136da032bfbfc7d.png" alt="">
          </div>
        </div>
      </div>

      <div class="precision-container">
        <h3 class="tit">精益求精<br/>多能兼备新标杆</h3>
        <h4>六种超声模式</h4>
        <p class="desc">满足不同需求</p>

        <div class="step-use">
          <div class="step-item">
            <h5 class="letter">G</h5>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260709/3ae5ea3eb593ae6311b558b3128a6132.png" alt="">
            <div class="explain-c">
              <div class="explain-b">
                <div>
                  <p class="explain-tit">高效洁治</p>
                </div>
                <div>
                  <p class="explain-tit">舒适洁治</p>
                </div>
              </div>
            </div>
          </div>
          <div class="step-item">
            <h5 class="letter">P</h5>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260709/36ec8168f43a6655071bb249529622b9.png" alt="">
            <div class="explain-c">
              <div class="explain-b">
                <div>
                  <p class="explain-tit">牙周治疗</p>
                </div>
                <div>
                  <p class="explain-tit">植体维护</p>
                </div>
              </div>
            </div>
          </div>
          <div class="step-item">
            <h5 class="letter">E</h5>
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260709/2117a3e94f6215e496cb4952800e5aac.png" alt="">
            <div class="explain-c">
              <div class="explain-b">
                <div>
                  <p class="explain-tit">牙髓治疗</p>
                </div>
                <div>
                  <p class="explain-tit">根管荡洗</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="scaling">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260716/1c3975c6a2a404ebfe041131543984bc.png" alt="">
        </div>
      </div>

      <div class="convenience-container">
        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260716/d8965675961763416eed83745fa4c7e9.jpg" alt="">
        <div class="convenience-content">
          <div class="main-txt">
            <h3 class="tit">细节强控<br/>卷出贴心新高度</h3>
            <h4>一键清洁 高效便捷</h4>
            <p class="desc">120s深度清洗与20s快速清洗任选<br/>
              一键同时冲洗喷砂与超声水路，省时省力，不惧客户高峰期</p>
          </div>
          <div class="params">
            <p>120s</p>
            <p>20s</p>
          </div>

          <div class="powder-container">
            <h4>光影出彩 美能兼备</h4>
            <p class="desc">粉罐LED呼吸灯设计，光影交错，流明幻变<br/>
              便于区分不同类型的喷砂粉，提高操作效率</p>
            <div class="clinical-operations">
              <div class="clinical-operation">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/832ca59684967b90e3c46046a3610085.jpg" alt="">
              </div>
              <div class="clinical-operation">
                <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/9af36e72785205340f175ba6b58b47cd.jpg" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="upgraded">
          <div class="upgraded-container">
            <div class="before">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/449659911758de3321aefb88616520d5.png" alt="">
              <p>PT-E</p>
            </div>
            <div class="after">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/9bddd7c1c3ed0ee954d42e3963799a61.png" alt="">
              <p>市面上喷砂机</p>
            </div>
            <div class="ps">
              <h4>夹管阀升级陶瓷阀</h4>
              <p class="desc">
                聚焦底部管理痛点<br/>
                降低爆管风险<br/>
                提升运行稳定性</p>
            </div>
          </div>
          <div class="glow"></div>
        </div>
      </div>

<!--      <div class="intelligent-interface">-->
<!--        <div class="intelligent-interface-container">-->
<!--          <div class="interface-info">-->
<!--            <h4>Adaptive Intelligent<br/>Interface</h4>-->
<!--            <p class="desc">The interface supports up to 15 languages and<br/>-->
<!--              features 3 adjustable screen brightness levels,<br/>-->
<!--              making it adaptable to various clinical environments.</p>-->
<!--            <div class="screen-img">-->
<!--              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/e8dd97347a511be4c46b31627c404e1b.png" alt="">-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="language-img">-->
<!--            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260704/2cee6162e2ea5510e48e171fd4513cfd.png" alt="">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="dental-cart-container">
        <div class="dental-cart-info">
          <h4>便捷收纳<br/>
            整洁有序</h4>
          <p class="desc">一体式小推车设计<br/>
            轻松收纳外接管路与线路<br/>
            优化诊室空间<br/>
            提升设备移动便捷性</p>
        </div>
        <div class="dental-cart-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260716/f5a1af52d091545c0d76adf741408436.png" alt="">
        </div>
      </div>

      <div class="maintenance-reminder-container">
        <div class="maintenance-reminder-info">
          <h4>维护提醒<br/>
            心中有数</h4>
          <p class="desc">新增喷砂尾线和粉罐维护提醒功能<br/>
            根据使用情况智能提醒尾线和粉罐更换</p>
        </div>
        <div class="maintenance-reminder-img">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260716/aaa29f8441a7095b9522bb8363df3d79.png" alt="">
        </div>
        <div class="glow"></div>
      </div>

<!--      <div class="accessories-container">-->
<!--        <div class="accessories-content">-->
<!--          <p>Accessories</p>-->
<!--          <div class="accessories-img">-->
<!--            <div class="txt">-->
<!--              <div>-->
<!--                <p>Periodontal<br/>-->
<!--                  treatment<br/>-->
<!--                  handpiece</p>-->
<!--                <p>31.08.01.009</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <p>Airstreaming<br/>supragingival<br/>handpiece</p>-->
<!--                <p>31.16.20.086-002</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <p>Airstreaming<br/>supragingival<br/>handpiece</p>-->
<!--                <p>31.16.20.087</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <p>Wireless<br/>multi-function<br/>foot pedal</p>-->
<!--                <p>31.16.06.153</p>-->
<!--              </div>-->

<!--              <div>-->
<!--                <p>lluminated powder<br/>-->
<!--                  container<br/>-->
<!--                  (Sodium bicarbonate)</p>-->
<!--                <p>31.16.06.216-008</p>-->
<!--              </div>-->

<!--              <div>-->
<!--                <p>Illuminated powder<br/>container<br/>-->
<!--                  (Erythritol/Glycine)</p>-->
<!--                <p>31.16.06.219-008</p>-->
<!--              </div>-->

<!--              <div>-->
<!--                <p>O-ring kit</p>-->
<!--                <p>31.16.06.241</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260705/fc499476ae1c5e9aa08bab774652f9d2.png" alt="">-->
<!--          </div>-->

<!--          <div class="parameters-content">-->
<!--            <p class="tit">parameters</p>-->
<!--            <p class="txt">-->
<!--              Output main vibration offset of tip (maximum): 90um; deviation: +50%<br/>Output vibrating frequency of tip: 30+5kHz<br/>-->
<!--              Output semi-offset force: 10N; deviation: +50%<br/>-->
<!--              Output power of tip: 3W ~ 20w<br/>-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->

<!--      </div>-->
    </div>

    <video-modal ref="videoModalRef"></video-modal>

  </div>

</template>

<script>
import circularProgress from "../components/progress-circle.vue";
import videoModal from '../components/video-modal.vue'

import viewButton from './components/button.vue'

export default {
  name: 'pt-e',
  components: {
    circularProgress,
    videoModal,
    viewButton
  },
  data(){
    return {
      videoList: [
        {
          ref: 'promotionalRef',
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/9a7086295001834811963777086/c5KKxYNWs14A.mp4',
          progress: 0,
          playing: false,
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/fcecdc5c5001834811217567354/JHzzvV1EAQAA.mp4',
          hasEntered: false,
          hasLeft: false
        }
      ],
    }
  },
  mounted() {

  },
  methods: {
    handleVisibility(isVisible, index) {
      const ref = this.videoList[index].ref;
      if (isVisible && !this.videoList[index].hasEntered) {
        this.$refs[ref].play().catch(e => console.log(ref + "视频播放失败:", e));
        this.videoList[index].playing = true
        this.videoList[index].hasEntered = true
        this.videoList[index].hasLeft = false
      } else if (!isVisible && !this.videoList[index].hasLeft) {
        this.$refs[ref].pause()
        this.videoList[index].playing = false
        this.videoList[index].hasLeft = true
        this.videoList[index].hasEntered = false
      }
    },
    togglePlay(index) {
      const ref = this.videoList[index].ref;
      this.videoList[index].playing = !this.videoList[index].playing;
      if(this.videoList[index].playing){
        this.$refs[ref].play().catch(e => console.log(ref + "视频播放失败:", e));
      }else {
        this.$refs[ref].pause();
      }
    },
    openVideoModal(url){
      this.$refs.videoModalRef.open(url)
    },
  }
};
</script>

<style>
h1, h2, h3, h4, h5, h6, p {
  padding: 0;
  margin: 0;
}

.pt-e-detail h1, .pt-e-detail h2, .pt-e-detail h3 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
}

.pt-e-detail h4, .pt-e-detail h5, .pt-e-detail h6 {
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 20px;
  color: #1B1B1B ;
}
.pt-e-detail p {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 20px;
  color: #7d7d7d ;
  margin: 0;
  padding: 0;
}
.pt-e-detail {
  position: relative;
}
.pt-e-detail img {
  display: block;
  width: 100%;
}
.pt-e-detail .pt-e-banner {
  position: relative;
  width: 100%;
  height: 100%;
}
.pt-e-detail .pt-e-banner .pt-e-banner-txt {
  width: 100%;
  position: absolute;
  top: 135px;
}
.pt-e-detail .pt-e-banner .pt-e-banner-txt p {
  color: #ffffff;
  font-size: 26px;
  text-align: center;
  margin-top: 37px;
}
.pt-e-detail .pt-e-banner  .pt-e-banner-txt .p-title {
  width: 270px;
  margin: 0 auto;
}
.pt-e-detail .pt-e-banner .pt-e-banner-img {}
.pt-e-detail .pt-e-banner .pt-e-banner-img img {

}

.pt-e-detail .promotional-cover {
  position: relative;
}

.pt-e-detail .promotional-cover .background-video {
  width: 100%;
  height: 100vh;
  object-fit: cover;
  display: block;
}
.pt-e-detail .mask {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  z-index: 3;
}

.pt-e-detail .promotional-cover .mask .content {
  margin-top: 218px;
}
.pt-e-detail .promotional-cover .mask .content h3 {
  color: #ffffff;
  text-align: center;
  font-size: 56px;
  line-height: 114px;
}
.pt-e-detail .promotional-cover .mask .content .button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}
.pt-e-detail .promotional-cover .progress {
  position: absolute;
  right: 40px;
  top: 20px;
  z-index: 5;
}

.pt-e-detail h3 {
  font-size: 80px;
}

.pt-e-detail h4 {
  font-size: 45px;
  margin-bottom: 26px;
}

.pt-e-detail .desc {
  font-size: 18.3px;
  line-height: 1.8;
}

.pt-e-detail .power-container {
  text-align: center;
  padding-bottom: 160px;
}

.pt-e-detail .power-container .tit {
  background: linear-gradient(
      90deg,
      #8000ff 0%,
      #9933ff 39%,
      #b366ff 42%,
      #cc99ff 60%,
      #e6ccff 80%,
      #f5e6ff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-top: 140px;
  margin-bottom: 110px;

}

.pt-e-detail .power-container .desc {
  line-height: 1.4;
}

.pt-e-detail .power-container .num {
  background: linear-gradient(
      110deg,
      #6000ff 0%,    /* 3的左下角最深 */
      #7d2aff 45%,
      #9a54ff 48%,
      #b77eff 50%,
      #d4a8ff 52%,
      #f1d2ff 100%   /* %的右上角最浅 */
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 72px;
  line-height: 1.4;
}

.pt-e-detail .power-container .model {
  width: 1050px;
  margin: 14px auto 0 auto;
  background: linear-gradient(to bottom, #ffffff, #f5f5fa);
  position: relative;
}
.pt-e-detail .power-container .model p {

}

.pt-e-detail .power-container .model-tit {
  position: absolute;
  top: 180px;
  font-size: 26px;
}
.pt-e-detail .power-container .model-tit.previous {
  left: 218px;
}
.pt-e-detail .power-container .model-tit.new {
  right: 225px;
}

.pt-e-detail .feature-container {
  position: relative;
}
.pt-e-detail .feature-container .feature-bg {}
.pt-e-detail .feature-container .feature-content {
  position: absolute;
  top: 153px;
  left: 445px;
}
.pt-e-detail .feature-container .feature-content p{
  color: #ffffff;
  font-size: 16.5px;
  line-height: 1.9;
}

.pt-e-detail .feature-container .feature-content p:nth-child(1) {
  font-size: 43px;
  margin-top: 28px;
}
.pt-e-detail .feature-container .feature-content p:nth-child(2) {
  font-size: 17.6px;
  margin-top: 28px;
}

.pt-e-detail .feature-container .feature-content p:nth-child(4) {
  font-size: 64px;
  line-height: 1.3;
}

.pt-e-detail .feature-container .feature-content p:nth-child(5) {
  margin-top: 5px;
}

.pt-e-detail .feature-container .feature-content .params {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.pt-e-detail .feature-container .feature-content .params.pt-e-c {
  margin-top: 30px;
}
.pt-e-detail .feature-container .feature-content .params.Standard-c {
  margin-top: 33px;
}

.pt-e-detail .feature-container .feature-content .params div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #dcd4ff;
  padding: 0 12px;
}
.pt-e-detail .feature-container .feature-content .params div p {
  color: #312252!important;
  font-size: 18px;
  margin-top: 0;
}
.pt-e-detail .feature-container .feature-content .params .pt-e{
  width: 284px;
}
.pt-e-detail .feature-container .feature-content .params .Standard {
  width: 414px;
}
.pt-e-detail .feature-container .feature-content .params .tit {
  margin-left: 26px;
  margin-top: 0;
}


.pt-e-detail .heating-system-container {
  text-align: center;
  background: linear-gradient(to bottom, #fefefe, #f6f6fa);
}
.pt-e-detail .heating-system-container h4 {
  margin-top: 104px;
  margin-bottom: 18px;
}

.pt-e-detail .heating-system-container .desc {
  margin-top: 15px;
  font-size: 17.5px;
  line-height: 2;
}

.pt-e-detail .heating-system-container .heating-system-img {
  width: 1030px;
  margin: 30px auto 0 auto;
}
.pt-e-detail .heating-system-container .upgraded {
  display: flex;
  justify-content: flex-start;
  margin-top: 140px;
}
.pt-e-detail .heating-system-container .upgraded .img {
  width: 582px;
  margin-left: 445px;
}
.pt-e-detail .heating-system-container .upgraded h4 {
  margin-top: 0;
  line-height: 0.9;
  font-size: 43px;
}

.pt-e-detail .heating-system-container .upgraded .txt {
  margin-left: 90px;
  margin-top: 150px;

}
.pt-e-detail .heating-system-container .upgraded h4 {
  text-align: left;
}
.pt-e-detail .heating-system-container .upgraded .txt .desc {
  text-align: left;
  font-size: 18px;
  margin-top: 35px;
  line-height: 1.8;
}

.pt-e-detail .heating-system-container .upgraded .patent-num{
  color: #9b86e3;
  font-size: 14.3px;
}

.pt-e-detail .heating-system-container .titanium-alloy {
  margin-top: 136px;
  position: relative;
  padding-top: 10px;
}
.pt-e-detail .heating-system-container .titanium-alloy .txt {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0px;
}
.pt-e-detail .heating-system-container .titanium-alloy .txt h4 {
  margin-top: 12px;
  font-size: 39px;
}
.pt-e-detail .heating-system-container .titanium-alloy .txt p {
  //font-size: 16.2px;
  margin-top: 30px;
}


.pt-e-detail .precision-container {
  text-align: center;
}
.pt-e-detail .precision-container .tit {
  background: linear-gradient(
      90deg,
      #8000ff 0%,
      #9933ff 39%,
      #b366ff 50%,
      #cc99ff 75%,
      #c8a4ff 80%,
      #c19bff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-top: 160px;
  margin-bottom: 105px;
}

.pt-e-detail .precision-container h4 {
  margin-top: 10px;
  margin-bottom: 10px;
}
.pt-e-detail .precision-container .desc {

}

.pt-e-detail .precision-container .step-use {
  display: flex;
  justify-content: center;
  margin-top: 98px;
}

.pt-e-detail .precision-container .step-use .step-item {
  width: 350px;
  margin-left: 112px;
  position: relative;
}
.pt-e-detail .precision-container .step-use .step-item:first-child {
  margin-left: 0;
}
.pt-e-detail .precision-container .step-use .step-item .letter {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 110px;
  color: #f46c62;
  top: -72px;
}

.pt-e-detail .precision-container .step-use .step-item .explain-c {
  position: absolute;
  top: 172px;
  width: 100%;
}
.pt-e-detail .precision-container .step-use .step-item .explain-b {
  text-align: left;
  display: flex;
  justify-content: flex-start;
}

.pt-e-detail .precision-container .step-use .step-item .explain-b div {

}


.pt-e-detail .precision-container .step-use .step-item .explain-c .explain-b .explain-tit {
  font-size: 17px;
  color: #575656;
}


.pt-e-detail .precision-container .step-use .step-item .explain-c .explain-b p {
  font-size: 13px;
}

.pt-e-detail .precision-container .step-use .step-item:first-child .explain-c .explain-b div:first-child {
  position: absolute;
  left: 66px;
  top: 18px;
}
.pt-e-detail .precision-container .step-use .step-item:first-child .explain-c .explain-b div:last-child {
  position: absolute;
  right: 75px;
  top: 18px;
}

.pt-e-detail .precision-container .step-use .step-item:nth-child(2) .explain-c .explain-b div:first-child {
  position: absolute;
  left: 62px;
  top: 18px;
}
.pt-e-detail .precision-container .step-use .step-item:nth-child(2) .explain-c .explain-b div:last-child {
  position: absolute;
  right: 66px;
  top: 18px;
}
.pt-e-detail .precision-container .step-use .step-item:nth-child(2) .explain-c .explain-b div:last-child .explain-tit {
}


.pt-e-detail .precision-container .step-use .step-item:nth-child(3) .explain-c .explain-b div:first-child {
  position: absolute;
  left: 52px;
  top: 18px;
}
.pt-e-detail .precision-container .step-use .step-item:nth-child(3) .explain-c .explain-b div:last-child {
  position: absolute;
  right: 64px;
  top: 18px;
}

.pt-e-detail .precision-container .scaling {
  width: 1290px;
  margin: 90px auto 138px auto;
}


.pt-e-detail .convenience-container {
  position: relative;
}

.pt-e-detail .convenience-container .convenience-content h4 {
  color: #ffffff;
}
.pt-e-detail .convenience-container .convenience-content p {
  color: #ffffff;
}
.pt-e-detail .convenience-container .convenience-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

.pt-e-detail .convenience-container .convenience-content .tit {
  background: linear-gradient(
      90deg,
      #dfcfff 0%,
      #baa3e7 39%,
      #a88edb 50%,
      #977ad1 75%,
      #8a6bc8 80%,
      #7f5dc1 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.pt-e-detail .convenience-container .convenience-content {

}

.pt-e-detail .convenience-container .convenience-content .main-txt {
  text-align: center;
  margin-top: 140px;
}

.pt-e-detail .convenience-container .convenience-content .main-txt h4 {
  margin-top: 70px;
  margin-bottom: 20px;
  font-size: 42px;
}

.pt-e-detail .convenience-container .convenience-content .main-txt .desc {
  line-height: 1.8;
}
.pt-e-detail .convenience-container .convenience-content .params {
  margin-left: 599px;
  margin-top: 120px;
}
.pt-e-detail .convenience-container .convenience-content .params p {
  color: #ffffff;
  font-size: 65px;

}

.pt-e-detail .convenience-container .convenience-content .params p:last-child {
  margin-top: 68px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container {
  text-align: center;
  margin-top: 425px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container h4{
  font-size: 42px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container .desc {
  margin-top: 30px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container .clinical-operations {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container .clinical-operations .clinical-operation {
  width: 498px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container .clinical-operations .clinical-operation p {
  margin-top: 16px;
}

.pt-e-detail .convenience-container .convenience-content .powder-container .clinical-operations .clinical-operation:last-child {
  margin-left: 50px;
}

.pt-e-detail .convenience-container .upgraded{
  background-color: #000000;
  padding-top: 70px;
  padding-bottom: 70px;
  position: relative;
  overflow: hidden;
}
.pt-e-detail .convenience-container .upgraded .upgraded-container{
  display: flex;
  padding-left: 440px;
  position: relative;
  z-index: 2;
}

.pt-e-detail .convenience-container .upgraded .upgraded-container .before,
.pt-e-detail .convenience-container .upgraded .upgraded-container .after {
  width: 260px;
  text-align: center;
}

.pt-e-detail .convenience-container .upgraded .upgraded-container .before p,
.pt-e-detail .convenience-container .upgraded .upgraded-container .after p {
  margin-top: 28px;
  font-size: 18px;
}

.pt-e-detail .convenience-container .upgraded .upgraded-container .after {
  margin-left: 91px;
}

.pt-e-detail .convenience-container .upgraded .upgraded-container .ps {
  margin-left: 63px;
  margin-top: 170px;
}
.pt-e-detail .convenience-container .upgraded .upgraded-container .before p,
.pt-e-detail .convenience-container .upgraded .upgraded-container .after p,
.pt-e-detail .convenience-container .upgraded .upgraded-container .ps p,
.pt-e-detail .convenience-container .upgraded .upgraded-container .ps h4 {
  color: #ffffff;
}

.pt-e-detail .convenience-container .upgraded .upgraded-container .ps h4 {
  line-height: 1.3;
}

.pt-e-detail .convenience-container .upgraded .glow {
  position: absolute;
  width: 2000px;
  height: 1600px;
  bottom: -850px;
  border-radius: 50%;
  left: 50%;
  transform: translateX(-50%);
  //background: rgba(84,67,118,0.7);
  //z-index: 1;
  background: radial-gradient(circle at center, rgba(87, 69, 122,.6) 20%, transparent 60%), #000000;
}

.pt-e-detail .intelligent-interface {
  background: linear-gradient(
      180deg,
      #000000 0%,
      #0a0615 70%,
      #150b28 95%,
      #1a0f30 100%
  );
  padding-left: 446px;
  padding-bottom: 115px;

}
.pt-e-detail .intelligent-interface .intelligent-interface-container {
  display: flex;
  justify-content: flex-start;
}

.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info {
}
.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info h4,
.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info p {
  color: #ffffff;
}

.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info h4 {
  padding-top: 195px;
  margin-bottom: 45px;
}
.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info p {
  font-size: 19px;
  line-height: 1.4;
}
.pt-e-detail .intelligent-interface .intelligent-interface-container .interface-info .screen-img {
  width: 360px;
  margin-top: 120px;
}

.pt-e-detail .intelligent-interface .intelligent-interface-container .language-img {
  width: 358px;
  margin-top: 130px;
  margin-left: 150px;
}


.pt-e-detail .dental-cart-container {
  background-color: #000000;
  padding-top: 130px;
  position: relative;
}

.pt-e-detail .dental-cart-container .dental-cart-img {
  width: 1030px;
  margin: 0 auto 0 auto;
  background: linear-gradient(
      180deg,
      #000000 0%,
      #0a0615 70%,
      #150b28 95%,
      #1a0f30 100%
  );
}

.pt-e-detail .dental-cart-container .dental-cart-info {
  position: absolute;
  left: 855px;
  top: 130px;
  text-align: center;
}
.pt-e-detail .dental-cart-container .dental-cart-info h4 {
  color: #ffffff;
  margin-bottom: 12px;
  font-size: 40px;
}
.pt-e-detail .dental-cart-container .dental-cart-info p {
  color: #ffffff;
  line-height: 1.8;
  margin-top: 29px;
  font-size: 18px;
}


.pt-e-detail .maintenance-reminder-container {

  background-color: #000000;
  padding-top: 30px;
  position: relative;
  overflow: hidden;
}

.pt-e-detail .maintenance-reminder-container .maintenance-reminder-info {
  position: absolute;
  left: 810px;
  top: 185px;
  text-align: center;
  z-index: 3;
}

.pt-e-detail .maintenance-reminder-container .maintenance-reminder-img {
  position: relative;
  z-index: 3;
}
.pt-e-detail .maintenance-reminder-container .maintenance-reminder-info h4 {
  color: #ffffff;
  margin-bottom: 22px;
  font-size: 40px;
}
.pt-e-detail .maintenance-reminder-container .maintenance-reminder-info p {
  color: #ffffff;
  font-size: 18px;
}

.pt-e-detail .maintenance-reminder-container .glow {
  position: absolute;
  width: 3000px;
  height: 2000px;
  bottom: -1200px;
  border-radius: 50%;
  left: 850px;
  transform: translateX(-50%);
  //background: rgba(84,67,118,0.7);
  //z-index: 1;
  background: radial-gradient(circle at center, rgba(87, 69, 122,.6) 20%, transparent 60%), #000000;
  z-index: 2;
}



.pt-e-detail .accessories-container {
  background-color: #000000;

}

.pt-e-detail .accessories-container .accessories-content {
  padding-top: 92px;
}

.pt-e-detail .accessories-container .accessories-content p {
  color: #ffffff;
  font-size: 28px;
}

.pt-e-detail .accessories-container {
  padding-bottom: 160px;
}
.pt-e-detail .accessories-container .accessories-content {
  width: 1025px;
  margin: 0 auto 0 auto;
}
.pt-e-detail .accessories-container .accessories-content .accessories-img {
  margin-top: 60px;
  position: relative;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div {
  padding: 33px 0 0 117px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(2){
  padding-left: 138px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(3){
  padding-left: 132px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(4){
  padding-left: 209px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(5){
  padding-top: 102px;
  padding-left: 118px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(6){
  padding-top: 102px;
  padding-left: 160px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div:nth-child(7){
  padding-top: 116px;
  padding-left: 333px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div p {
  font-size: 14px;
}

.pt-e-detail .accessories-container .accessories-content .accessories-img .txt div p:nth-child(2){
  margin-top: 16px;
}

.pt-e-detail .accessories-container .accessories-content .parameters-content {
  margin-top: 93px;
}

.pt-e-detail .accessories-container .accessories-content .parameters-content .tit {}
.pt-e-detail .accessories-container .accessories-content .parameters-content .txt {
  margin-top: 35px;
  font-size: 14px;
  line-height: 1.7;
}

</style>